__turbopack_context__.v({
  "app_light_theme": "HeroInfoTriggers-module-scss-module__Yz2ENa__app_light_theme",
  "description": "HeroInfoTriggers-module-scss-module__Yz2ENa__description",
  "heroInfoTriggers": "HeroInfoTriggers-module-scss-module__Yz2ENa__heroInfoTriggers",
  "item": "HeroInfoTriggers-module-scss-module__Yz2ENa__item",
  "postDescription": "HeroInfoTriggers-module-scss-module__Yz2ENa__postDescription",
  "title": "HeroInfoTriggers-module-scss-module__Yz2ENa__title",
});
